import { InputType, PropListType } from '../../store/inputs/types';

export const CreateTypeInputs = [
  {
    tag: 'tag',
    dataType: 'string',
    label: 'Tag',
    name: 'tag',
    value: '',
    required: true,
    error: '',
    disabled: false,
    route: '',
    isKey: true,
    isEdit: false,
    onChange: () => {},
    clearValue: () => {},
    toggleDisabled: () => {},
  } as InputType,
  {
    tag: 'label',
    dataType: 'string',
    label: 'Label',
    name: 'label',
    value: '',
    required: false,
    error: '',
    disabled: false,
    route: '',
    isKey: false,
    isEdit: false,
    onChange: () => {},
    clearValue: () => {},
    toggleDisabled: () => {},
  } as InputType,
  {
    tag: 'description',
    dataType: 'string',
    label: 'Description',
    name: 'description',
    value: '',
    required: false,
    error: '',
    disabled: false,
    route: '',
    isKey: false,
    isEdit: false,
    onChange: () => {},
    clearValue: () => {},
    toggleDisabled: () => {},
  } as InputType,
];

export const CreatePropInput = {
  tag: 'props',
  dataType: '[]@prop',
  label: 'Props',
  name: 'props',
  value: [],
  selectorValue: null,
  required: true,
  error: '',
  disabled: false,
  route: '',
  isKey: false,
  isEdit: false,
  onChange: () => {},
  onChangeValue: () => {},
  props: [
    {
      tag: 'tag',
      dataType: 'string',
      label: 'Tag',
      name: 'tag',
      required: true,
      error: '',
      disabled: false,
      route: '',
      isKey: true,
      isEdit: false,
    } as InputType,
    {
      tag: 'label',
      dataType: 'string',
      label: 'Label',
      name: 'label',
      required: true,
      error: '',
      disabled: false,
      route: '',
      isKey: false,
      isEdit: false,
    } as InputType,
    {
      tag: 'description',
      dataType: 'string',
      label: 'Description',
      name: 'description',
      required: false,
      error: '',
      disabled: false,
      route: '',
      isKey: false,
      isEdit: false,
    } as InputType,
    {
      tag: 'required',
      dataType: 'boolean',
      label: 'Required?',
      name: 'required',
      required: false,
      error: '',
      disabled: false,
      route: '',
      isKey: false,
      isEdit: false,
    } as InputType,
    {
      tag: 'isKey',
      dataType: 'boolean',
      label: 'Is Key?',
      name: 'required',
      required: false,
      error: '',
      disabled: false,
      route: '',
      isKey: false,
      isEdit: false,
    } as InputType,
    {
      tag: 'readOnly',
      dataType: 'boolean',
      label: 'Read Only?',
      name: 'readOnly',
      required: false,
      error: '',
      disabled: false,
      route: '',
      isKey: false,
      isEdit: false,
    } as InputType,
    {
      tag: 'dataType',
      dataType: 'string',
      label: 'Data Type',
      name: 'dataType',
      required: true,
      error: '',
      disabled: false,
      route: '',
      isKey: false,
      isEdit: false,
    } as InputType,
    {
      tag: 'writers',
      dataType: '[]string',
      label: 'Writers',
      name: 'writers',
      required: false,
      error: '',
      disabled: false,
      route: '',
      isKey: false,
      isEdit: false,
    } as InputType,
    {
      tag: 'defaultValue',
      dataType: 'string',
      label: 'Default Value',
      name: 'defaultValue',
      required: false,
      error: '',
      disabled: false,
      route: '',
      isKey: false,
      isEdit: false,
    } as InputType,
  ],
} as PropListType;

export const DeleteTypeInputs = [
  {
    tag: 'tag',
    dataType: 'number',
    label: 'Tag',
    name: 'tag',
    required: true,
    error: '',
    disabled: false,
    route: '',
    isKey: true,
    isEdit: false,
  } as InputType,
  {
    tag: 'force',
    dataType: 'boolean',
    label: 'Force',
    name: 'force',
    required: false,
    error: '',
    disabled: false,
    route: '',
    isKey: false,
    isEdit: false,
  } as InputType,
];
